import apiClient from '@/services/axios'

const getAll = async () => {
  const res = await apiClient.get('/laboratorium')
  if (res) {
    return res.data
  } else {
    return []
  }
}

const getById = async (id) => {
  const res = await apiClient.get(`/laboratorium/${id}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

const deleteById = async (id) => {
  const res = await apiClient.delete(`/laboratorium/${id}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

const create = async (data) => {
  const res = await apiClient.post('/laboratorium', data, {})
  if (res) {
    return res
  } else {
    return null
  }
}

const editById = async (id, data) => {
  const res = await apiClient.patch(`/laboratorium/${id}`, data, {})
  if (res) {
    return res
  } else {
    return null
  }
}

export {
  getAll,
  getById,
  deleteById,
  create,
  editById,
}
